import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, withModifiers as _withModifiers, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-wrapper scroll-wrapper" }
const _hoisted_2 = { class: "modal-title modal-title-contact" }
const _hoisted_3 = {
  key: 0,
  class: "title-block"
}
const _hoisted_4 = { class: "modal__title" }
const _hoisted_5 = { class: "text-muted" }
const _hoisted_6 = {
  key: 1,
  class: "modal__title"
}
const _hoisted_7 = { class: "content-block scroll-wrapper" }
const _hoisted_8 = { class: "modal-content-contact" }
const _hoisted_9 = { class: "user-name-wrapper" }
const _hoisted_10 = { class: "form-group" }
const _hoisted_11 = {
  key: 0,
  class: "error"
}
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = {
  key: 0,
  class: "error"
}
const _hoisted_14 = { class: "user-name-wrapper" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = {
  key: 0,
  class: "error"
}
const _hoisted_17 = { class: "form-group" }
const _hoisted_18 = {
  key: 0,
  class: "error"
}
const _hoisted_19 = { class: "user-name-wrapper" }
const _hoisted_20 = { class: "form-group" }
const _hoisted_21 = {
  class: "dropdown-button input-dropdown",
  type: "button"
}
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  key: 0,
  class: "error"
}
const _hoisted_24 = { class: "form-group" }
const _hoisted_25 = {
  key: 0,
  class: "error"
}
const _hoisted_26 = { class: "form-group" }
const _hoisted_27 = {
  key: 1,
  class: "spinner"
}
const _hoisted_28 = { class: "buttons-wr-contact" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = {
  key: 1,
  class: "spinner spinner-small"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock($setup["Modal"], {
    "is-open": $setup.props.isOpen,
    onClose: $setup.onClose,
    classes: "contact-us-modal height-limited"
  }, {
    content: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          ($props.lot)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("button", {
                  class: "button icon back",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('back'))),
                  type: "button"
                }),
                _createElementVNode("div", _hoisted_4, [
                  _cache[8] || (_cache[8] = _createTextVNode("Make enquiry", -1)),
                  _createElementVNode("span", _hoisted_5, " (Lot " + _toDisplayString($props.lot.lotId.title) + ")", 1)
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, "Contact Us"))
        ]),
        _createElementVNode("div", _hoisted_7, [
          (!$setup.formLoad)
            ? (_openBlock(), _createElementBlock("form", {
                key: 0,
                class: "login-form",
                onSubmit: _withModifiers($setup.submitForm, ["prevent"])
              }, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("label", null, [
                        _cache[9] || (_cache[9] = _createElementVNode("span", { class: "label" }, "First name", -1)),
                        _withDirectives(_createElementVNode("input", {
                          class: _normalizeClass(["input-large", { 'input--error': $setup.v$.firstName.$error }]),
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.firstName) = $event)),
                          placeholder: "First Name"
                        }, null, 2), [
                          [_vModelText, $setup.form.firstName]
                        ])
                      ]),
                      ($setup.v$.firstName.$error)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_11, _toDisplayString($setup.v$.firstName.required.$message), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("label", null, [
                        _cache[10] || (_cache[10] = _createElementVNode("span", { class: "label" }, "Last Name", -1)),
                        _withDirectives(_createElementVNode("input", {
                          class: _normalizeClass(["input-large", { 'input--error': $setup.v$.lastName.$error }]),
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form.lastName) = $event)),
                          placeholder: "Last Name"
                        }, null, 2), [
                          [_vModelText, $setup.form.lastName]
                        ])
                      ]),
                      ($setup.v$.lastName.$error)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString($setup.v$.lastName.required.$message), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("label", null, [
                        _cache[11] || (_cache[11] = _createElementVNode("span", { class: "label" }, "Phone", -1)),
                        _createVNode($setup["Cleave"], {
                          class: _normalizeClass(["input input-large", { 'input--error': $setup.v$.phone.$error }]),
                          modelValue: $setup.form.phone,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.form.phone) = $event)),
                          options: $setup.phoneNumberOption($setup.form.phone),
                          placeholder: "0412 345 678"
                        }, null, 8, ["modelValue", "class", "options"])
                      ]),
                      ($setup.v$.phone.$error)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString($setup.v$.phone.$errors[0]?.$message), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("label", null, [
                        _cache[12] || (_cache[12] = _createElementVNode("span", { class: "label" }, "Email", -1)),
                        _withDirectives(_createElementVNode("input", {
                          class: _normalizeClass(["input-large", { 'input--error': $setup.v$.email.$error }]),
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.form.email) = $event)),
                          type: "email",
                          placeholder: "Email"
                        }, null, 2), [
                          [_vModelText, $setup.form.email]
                        ])
                      ]),
                      ($setup.v$.email.$error)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_18, _toDisplayString($setup.v$.email.$errors[0]?.$message), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("label", null, [
                        _cache[13] || (_cache[13] = _createElementVNode("span", { class: "label" }, "What best describes you?", -1)),
                        _createElementVNode("div", null, [
                          _createVNode($setup["DropDown"], { class: "dropdown-container" }, {
                            control: _withCtx(() => [
                              _createElementVNode("label", _hoisted_21, _toDisplayString($setup.form.holderType || "Please select"), 1)
                            ]),
                            dropdown: _withCtx(() => [
                              _createElementVNode("ul", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList([$setup.HolderType.INVESTOR, $setup.HolderType.OWNER_OCCUPIER, $setup.HolderType.FIRST_HOME_BUYER], (holder) => {
                                  return (_openBlock(), _createElementBlock("li", {
                                    key: holder,
                                    onClick: ($event: any) => ($setup.form.holderType = holder),
                                    class: _normalizeClass({ 'dropdown__item-active': holder === $setup.form.holderType })
                                  }, _toDisplayString(holder), 11, _hoisted_22))
                                }), 128))
                              ])
                            ]),
                            _: 1
                          })
                        ])
                      ]),
                      ($setup.v$.holderType.$error)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString($setup.v$.holderType.$errors[0]?.$message), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_24, [
                      _createElementVNode("label", null, [
                        _cache[14] || (_cache[14] = _createElementVNode("span", { class: "label" }, "Postcode", -1)),
                        _withDirectives(_createElementVNode("input", {
                          class: _normalizeClass(["input-large", { 'input--error': $setup.v$.postcode.$error }]),
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.form.postcode) = $event)),
                          placeholder: "e.g. 2000"
                        }, null, 2), [
                          [_vModelText, $setup.form.postcode]
                        ])
                      ]),
                      ($setup.v$.postcode.$error)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString($setup.v$.postcode.$errors[0]?.$message), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("label", null, [
                      _cache[15] || (_cache[15] = _createElementVNode("span", { class: "label" }, "Message", -1)),
                      _withDirectives(_createElementVNode("textarea", {
                        class: "textarea",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.form.message) = $event)),
                        placeholder: "Message"
                      }, null, 512), [
                        [_vModelText, $setup.form.message]
                      ])
                    ])
                  ])
                ])
              ], 32))
            : (_openBlock(), _createElementBlock("div", _hoisted_27))
        ]),
        _createElementVNode("div", _hoisted_28, [
          (!$setup.props.isLoading)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "button large primary reserve",
                type: "submit",
                disabled: $setup.props.isLoading,
                onClick: $setup.submitForm
              }, "Submit", 8, _hoisted_29))
            : (_openBlock(), _createElementBlock("div", _hoisted_30)),
          _createElementVNode("button", {
            class: "button reserve",
            type: "button",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('close')))
          }, "Cancel")
        ])
      ])
    ]),
    _: 1
  }, 8, ["is-open"]))
}